export default __webpack_public_path__ + "static/doctorBg-f5e48e02e64a3a8dee8620e7a9621aeb.svg";